module.exports = __webpack_public_path__ + "media/images/title_mobile@1x-efbcdb9ec17bc1fd19351a3b91f66354.png";